import React, { useContext, useEffect, useState } from "react";
import Column from "@amzn/meridian/column";
import Row from "@amzn/meridian/row";
import Link from "@amzn/meridian/link";
import Select, { SelectOption } from "@amzn/meridian/select";
import Text from "@amzn/meridian/text";
import Tag from "@amzn/meridian/tag";
import { OutboundFilterContext } from "../outboundAmzl/context/OutboundFilterContext";
import { FormattedMessage } from "react-intl";
import { getCycleDataFromParent } from "../handler/ParentDataHandler";
import { CycleFilterContext } from "../overview/context/CycleFilterContext";

const OutboundFilterARV2 = () => {
  const { cycles, dispatch } = useContext(CycleFilterContext);
  const { viewModelF, dispatchF } = useContext(OutboundFilterContext);
  const [filterState, setFilterState] = useState(false);

  const toggleFilter = () => {
    setFilterState(!filterState);
  };

  useEffect(() => {
    getCycleDataFromParent().then((cycleData) => {
      dispatch({ type: "INITIALIZE_CYCLES", cycleData });
    });
  }, []);

  return (
    <Column>
      <Row width="100%" spacingInset="large large none large">
        <Link href="" type="secondary" onClick={toggleFilter}>
          Options
        </Link>
        <div className="filter-tag">
          {Object.entries(viewModelF).map((entry) => {
            const key = entry[0];
            const values = entry[1];
            return Array.isArray(values) && key !== "data"
              ? values.map((value) => {
                  return (
                    <Tag
                      key={value}
                      type="neutral"
                      onClose={() =>
                        dispatchF({
                          type: "REMOVE_FILTER",
                          data: { key, value },
                        })
                      }
                    >
                      {value}
                    </Tag>
                  );
                })
              : null;
          })}
          {cycles.selectedCycles.map((cycle) => {
            return (
              <Tag key={cycle} type="neutral">
                {cycle}
              </Tag>
            );
          })}
        </div>
      </Row>
      {filterState ? (
        <Row
          width="100%"
          spacingInset="medium large"
          backgroundColor="secondary"
        >
          <Column
            heights="fill"
            alignmentHorizontal="left"
            spacingInset="none medium none"
          >
            <Text type="h100" alignment="left">
              <FormattedMessage
                id="outboundAMZL.departure"
                defaultMessage="Departure"
              />
            </Text>
            <Select
              onChange={(data) =>
                dispatchF({ type: "SELECT_DEPARTURE", Departure: data })
              }
              value={viewModelF.departure}
              size="small"
              placeholder="Departure"
              width={150}
            >
              {[...viewModelF.data.departure].sort().map((departure) => (
                <SelectOption
                  key={departure}
                  label={"Departing " + departure}
                  value={departure}
                />
              ))}
            </Select>
          </Column>
          <Column
            heights="fill"
            alignmentHorizontal="left"
            spacingInset="none medium none"
          >
            <Text type="h100" alignment="left">
              <FormattedMessage
                id="outboundAMZL.driverType"
                defaultMessage="Driver Type"
              />
            </Text>
            <Select
              onChange={(data) =>
                dispatchF({ type: "SELECT_DRIVER_TYPE", DriverType: data })
              }
              value={viewModelF.driverType}
              size="small"
              placeholder="Driver Type"
              width={150}
            >
              {[...viewModelF.data.driverType].sort().map((driverType) => (
                <SelectOption
                  key={driverType}
                  label={driverType}
                  value={driverType}
                />
              ))}
            </Select>
          </Column>
          <Column
            heights="fill"
            alignmentHorizontal="left"
            spacingInset="none medium none"
          >
            <Text type="h100" alignment="left">
              <FormattedMessage
                id="outboundAMZL.cluster"
                defaultMessage="Cluster"
              />
            </Text>
            <Select
              onChange={(data) =>
                dispatchF({ type: "SELECT_CLUSTER", Cluster: data })
              }
              value={viewModelF.cluster}
              size="small"
              placeholder="Cluster"
              width={150}
            >
              {[...viewModelF.data.cluster].sort().map((cluster) => (
                <SelectOption key={cluster} label={cluster} value={cluster} />
              ))}
            </Select>
          </Column>
        </Row>
      ) : null}
    </Column>
  );
};

export default OutboundFilterARV2;



// WEBPACK FOOTER //
// ./src/components/outboundOverview/OutboundFilterARV2.js